interface Props {
  tab: "aggregate" | "instances";
  onChange: (tab: "aggregate" | "instances") => void;
  drillLabel?: string;
}

export function TabSwitcher({ tab, onChange, drillLabel }: Props) {
  return (
    <div className="tabs">
      <div
        className={"tab " + (tab === "aggregate" ? "active" : "")}
        onClick={() => onChange("aggregate")}
      >
        Aggregate
      </div>
      <div
        className={"tab " + (tab === "instances" ? "active" : "")}
        onClick={() => onChange("instances")}
      >
        Instances {drillLabel ? `· filtered to ${drillLabel}` : ""}
      </div>
    </div>
  );
}
